import { getTransactionById } from '../services/UserTransaction/service';
import { RawScenarioPerformance } from '../types/api/scenario';
import { ScenarioPerformance } from '../types/models/scenarioPerformance';
import { UserStatistics } from '../types/ui/userStatistics';

export async function toScenarioPerformance(
  raw: RawScenarioPerformance,
  index: number,
  stats?: UserStatistics
): Promise<ScenarioPerformance> {
  const perf: Partial<ScenarioPerformance> = {
    id:               index + 1,
    speed:            raw.speed,
    accuracy_score:   raw.accuracy_score,
    shot_score:       raw.shot_score,
    hit_factor:       raw.hit_factor,
    n_hits:           raw.n_hits,
    hits_ratio:       raw.hits_ratio,
    averageSpeed:     raw.speed,
    averageAccuracy:  raw.accuracy_score,
    averageScore:     raw.shot_score,
    userTransactionId: raw.scenarioid,
    userTransaction:   null,
  };

  try {
    const scen = await getTransactionById(raw.scenarioid);
    perf.scenario = scen?.scenario_name ?? `#${raw.scenarioid}`;

    if (stats) {
      const match = stats.scenarios.find(s => s.name === scen?.scenario_name);
      if (match) {
        let trendDirection: 'up' | 'down' | 'neutral' = 'neutral';
        if (match.lastHitFactor > match.bestHitFactor) trendDirection = 'up';
        else if (match.lastHitFactor < match.bestHitFactor) trendDirection = 'down';

        perf.trend = {
          bestHitFactor: match.bestHitFactor,
          lastHitFactor: match.lastHitFactor,
          trend: trendDirection,
        };
      }
    }
  } catch {
    perf.scenario = `#${raw.scenarioid}`;
  }

  return perf as ScenarioPerformance;
}

export async function toScenarioPerformances(
  raws: RawScenarioPerformance[],
  stats?: UserStatistics
): Promise<ScenarioPerformance[]> {
  return Promise.all(raws.map((r, i) => toScenarioPerformance(r, i, stats)));
}
